import YQrcode from "./qrcode.vue";
const loading = {
    install: function (Vue) {
        Vue.component("YQrcode", YQrcode)
    }
}
export default loading;